import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import brandTheme from "brandTheme/Theme";
const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    overflowY: "auto",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    width: "92%",
    margin: "0 auto",
  },

  content: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
  },

  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },

  containers: {
    padding: "8px 40px",
  },

  card: {
    borderRadius: 20,
    marginBottom: 30,
  },

  addressCard: {
    borderRadius: 20,
  },

  sectionTitle: {
    color: brandTheme.buttonHoverColor,
    fontWeight: 700,
  },

  sectionSubTitle: {
    color: "#777",
  },

  profileImage: {
    width: 170,
    height: 170,
    borderRadius: 16,
  },

  label: {
    color: "#777",
    fontSize: 14,
  },

  value: {
    color: "#15254F",
    fontWeight: 600,
    fontSize: 18,
  },

  addressHeading: {
    fontWeight: 600,
    fontSize: 18,
    color: brandTheme.buttonHoverColor,
  },

  addressGrid: {
    marginTop: 10,
  },

  headerBox: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
  },

  headerContent: {
    marginLeft: theme.spacing(3),
  },

  sectionSpacing: {
    marginTop: theme.spacing(4),
  },
  iconWrapper: {
    width: 60,
    height: 60,
    borderRadius: 14,
    background: "#EAF8F1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  sectionIcon: {
    fontSize: 30,
    color: brandTheme.secondaryColor,
  },

  title: {
    fontSize: 20,
    fontWeight: 700,
    color: brandTheme.mainColor,
  },

  subTitle: {
    fontSize: 14,
    color: "#6B7280",
  },
}));

const ProfileDetails = () => {
  const classes = useStyles();
  const { mobileNumber, name } = useSelector((state) => state.login.userData);
  const userProfileInfo = useSelector(
    (state) => state.login.userProfileInfo
  );
  const [callInProgress, setCallInProgress] = useState(false);
  const [addressDetails, setAddressDetails] = useState(userProfileInfo?.[0]?.address);
  const [userMobileInfo, setUserMobileInfo] = useState(userProfileInfo?.[0]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const itemView = (label, value) => (
    <Grid item xs={12} sm={6} md={3}>
      <Box display="flex" alignItems="center">
        <Box>
          <Typography className={classes.label}>{label}</Typography>

          <Typography className={classes.value}>{value || "NA"}</Typography>
        </Box>
      </Box>
    </Grid>
  );
  const getAddress = (addresss = {}) => {
    let address = "";

    if (addresss?.houseNo) {
      address += addresss.houseNo;
    }

    if (addresss?.street) {
      if (address) address += ", ";
      address += addresss.street;
    }

    if (addresss?.locality) {
      if (address) address += ", ";
      address += addresss.locality;
    }

    if (addresss?.postOffice) {
      if (address) address += ", ";
      address += addresss.postOffice;
    }

    if (addresss?.city) {
      if (address) address += ", ";
      address += addresss.city;
    }

    if (addresss?.state) {
      if (address) address += ", ";
      address += addresss.state;
    }

    if (addresss?.district) {
      if (address) address += ", ";
      address += addresss.district;
    }

    if (addresss?.pincode) {
      if (address) address += ", ";
      address += addresss.pincode;
    }

    return address;
  };
  const customerInfo = [
    {
      label: "Customer Id",
      value: userMobileInfo?.customerId,
    },
    {
      label: "Name",
      value: userMobileInfo?.applicantName,
    },
    {
      label: "Father Name",
      value: userMobileInfo?.fatherName,
    },
    {
      label: "DOB",
      value: userMobileInfo?.dateOfBirth,
    },
    {
      label: "Mobile Number",
      value: userMobileInfo?.communication?.primarymobileNumber,
    },
    {
      label: "E-mail",
      value: userMobileInfo?.communication?.primaryEmail,
    },
    {
      label: "PAN",
      value: userMobileInfo?.panNumber,
    },
    {
      label: "Aadhaar Number",
      value: userMobileInfo?.adharNumber,
    },
  ];
  console.log(userMobileInfo, "ajksdhkahk");
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="Profile Information" />
      </Grid>
      <Grid container className={classes.content}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card elevation={2} className={classes.card}>
            <CardContent>
              <Box display="flex" alignItems="center">
                <Box className={classes.iconWrapper}>
                  <PersonOutlineIcon className={classes.sectionIcon} />
                </Box>

                <Box ml={2}>
                  <Typography className={classes.title}>
                    Customer Information
                  </Typography>
                  <Typography className={classes.subTitle}>
                    Your personal and contact details
                  </Typography>
                </Box>
              </Box>

              <Divider />

              <Box className={classes.sectionSpacing}>
                <Grid container spacing={4}>
                  <Grid item md={2}>
                    <Avatar
                      src={userMobileInfo?.photo}
                      variant="rounded"
                      className={classes.profileImage}
                    />
                  </Grid>

                  <Grid item md={10}>
                    <Grid container spacing={4}>
                      {customerInfo.map(({ label, value }) => (
                        <React.Fragment key={label}>
                          {itemView(label, value)}
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
          {addressDetails && addressDetails?.length > 0 && (
            <Card elevation={2} className={classes.addressCard}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <Box className={classes.iconWrapper}>
                    <HomeOutlinedIcon className={classes.sectionIcon} />
                  </Box>

                  <Box ml={2}>
                    <Typography className={classes.title}>
                      Address Details
                    </Typography>
                    <Typography className={classes.subTitle}>
                      Permanent and Corresponding Address
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                <Grid container spacing={4} className={classes.addressGrid}>
                  <Grid item md={6}>
                    <Box display="flex">
                      <Box>
                        <Typography className={classes.addressHeading}>
                          Permanent Address
                        </Typography>

                        <Typography color="textSecondary">
                          {getAddress(addressDetails?.[0]?.fullAddress) || "NA"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item md={6}>
                    <Box display="flex">
                      <Box>
                        <Typography className={classes.addressHeading}>
                          Corresponding Address
                        </Typography>

                        <Typography color="textSecondary">
                          {getAddress(addressDetails?.[1]?.fullAddress) || "NA"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default ProfileDetails;